import { Box, Grid, InputAdornment, MenuItem, Select, TextField, Tooltip } from '@mui/material'
import CheckboxLabel from '../../../../components/CheckboxLabel/CheckboxLabel'
import { t } from 'i18next'
import { HelpCircle } from 'react-feather'
import palette from '../../../../theme/palette'
import React from 'react'
import { checkboxLabelStyle, inlineSelect, inlineTextfield } from './SettingsList.styles'
import { AdvanceSettings } from './AdvanceSettings'

type SettingsProps = {
	advanceSettings: any
	setAdvanceSettings: any
	handlePropChange: any
}

const features = {
	skip_answered: false,
	defer_finish: false,
	program_campaign: false,
	rerun_campaign: false,
}

export default function SettingsList({ advanceSettings, setAdvanceSettings, handlePropChange }: SettingsProps) {
	return (
		<Grid item xs={12} sx={{ paddingTop: '16px!important', paddingLeft: '20px!important' }}>
			{features.skip_answered && (
				<Box display="flex">
					<Box sx={checkboxLabelStyle}>
						<CheckboxLabel
							label="Skip ‘Answered’ calls when running the campaign more than once."
							checkboxProps={{
								onChange: (evt) => handlePropChange(AdvanceSettings.SKIP_ANSWERED, evt),
								checked: advanceSettings[AdvanceSettings.SKIP_ANSWERED],
								disabled: true,
							}}
						/>
					</Box>
				</Box>
			)}
			<Box display="flex">
				<Box sx={checkboxLabelStyle}>
					<CheckboxLabel
						label="Call 'uncalled' numbers only."
						checkboxProps={{
							onChange: (evt) => handlePropChange(AdvanceSettings.CALL_UNCALLED_ONLY, evt),
							checked: advanceSettings[AdvanceSettings.CALL_UNCALLED_ONLY],
						}}
					/>
				</Box>
				<Tooltip title={t('retry_campaign_tooltip')} placement="top" arrow>
					<HelpCircle style={{ alignSelf: 'center', color: palette.brand.main, width: '1rem' }} />
				</Tooltip>
			</Box>
			{features.defer_finish && (
				<Box display="flex">
					<Box sx={checkboxLabelStyle}>
						<CheckboxLabel
							label="Finish this campaign the next day if I run out of credits."
							checkboxProps={{
								onChange: (evt) => handlePropChange(AdvanceSettings.FINISH_IF_NO_CREDITS, evt),
								checked: advanceSettings[AdvanceSettings.FINISH_IF_NO_CREDITS],
								disabled: true,
							}}
						/>
					</Box>
				</Box>
			)}
			{features.program_campaign && (
				<Box display="flex">
					<Box sx={checkboxLabelStyle}>
						<CheckboxLabel
							label={
								<>
									Automatically run this campaign a second time{' '}
									<Select
										sx={inlineSelect}
										value={advanceSettings[AdvanceSettings.AUTORUN_AFTER_COMPLETED_HOURS]}
										onChange={(evt) =>
											setAdvanceSettings({
												...advanceSettings,
												[AdvanceSettings.AUTORUN_AFTER_COMPLETED_HOURS]: Number(
													evt.target.value,
												),
											})
										}
										name={AdvanceSettings.AUTORUN_AFTER_COMPLETED_HOURS}
									>
										<MenuItem value={2} sx={{ fontSize: '14px' }}>
											2 hours
										</MenuItem>
										<MenuItem value={3} sx={{ fontSize: '14px' }}>
											3 hours
										</MenuItem>
										<MenuItem value={4} sx={{ fontSize: '14px' }}>
											4 hours
										</MenuItem>
									</Select>{' '}
									after it has completed.
								</>
							}
							checkboxProps={{
								onChange: (evt) => handlePropChange(AdvanceSettings.AUTORUN_AFTER_COMPLETED, evt),
								checked: advanceSettings[AdvanceSettings.AUTORUN_AFTER_COMPLETED],
								disabled: true,
							}}
						/>
					</Box>
				</Box>
			)}
			{features.program_campaign && (
				<Box display="flex">
					<Box sx={checkboxLabelStyle}>
						<CheckboxLabel
							label={
								<Box sx={{ display: 'flex', alignItems: 'center' }}>
									Finish this campaign the next day at
									<TextField
										name={AdvanceSettings.FINISH_IF_NO_CREDITS_TIME}
										value={advanceSettings[AdvanceSettings.FINISH_IF_NO_CREDITS_TIME]}
										variant="outlined"
										type="time"
										InputProps={{
											style: { fontSize: '14px' },
											endAdornment: (
												<InputAdornment
													position="end"
													sx={{
														'.MuiTypography-body1': { fontSize: '14px!important' },
													}}
												>
													EST
												</InputAdornment>
											),
										}}
										onChange={(evt) => {
											console.log(evt)
											setAdvanceSettings({
												...advanceSettings,
												[AdvanceSettings.FINISH_IF_NO_CREDITS_TIME]: evt.target.value,
											})
										}}
										sx={inlineTextfield}
									/>{' '}
									if I run out of credits.
								</Box>
							}
							checkboxProps={{
								onChange: (evt) => handlePropChange(AdvanceSettings.FINISH_RUN_OUT_CREDITS, evt),
								checked: advanceSettings[AdvanceSettings.FINISH_RUN_OUT_CREDITS],
								disabled: true,
							}}
						/>
					</Box>
				</Box>
			)}
		</Grid>
	)
}
